// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__k4-rY","school":"ComboboxCoso_school__ZCrsx","logo":"ComboboxCoso_logo__sCqBv","name":"ComboboxCoso_name__BHsuH"};